import { branchOfficeService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { BranchOfficeUpdatePayload } from '../../../../../../../../../../../services/branch-office-service.types';

export const useUpdateBranchOffice = (branchOfficeId: string) => {
  const mutationFn = async (branchOffice: BranchOfficeUpdatePayload) =>
    await branchOfficeService.updateBranchOffice(branchOfficeId, branchOffice);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.branchOffices());
    },
  });
};
